import React, { Component } from "react";
import { Layout, Breadcrumb, Button, PageHeader } from "antd";
import { RightOutlined } from "@ant-design/icons";
import UserTable from "./UserTable.js";
import UserForm from "./UserForm.js";

import { getOne as getUser } from "../../api/User.js";

const { Content } = Layout;

/**
 *
 */
class Users extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    this.state = {
      showUserForm: false,
      userToEdit: null,
    };

    this.userTable = React.createRef();

    this.onCreatedHandler = this.onCreatedHandler.bind(this);
    this.onUserEditHandler = this.onUserEditHandler.bind(this);
    this.addUser = this.addUser.bind(this);
  }

  /**
   *
   */
  onCreatedHandler = () => {
    this.userTable.current.fetch({
      current: 1,
      pageSize: 10,
    });

    this.setState({
      showUserForm: false,
    });
  };

  /**
   *
   */
  addUser = () => {
    this.setState({
      showUserForm: true,
    });
  };

  onUserEditHandler = async (userId) => {
    getUser(userId)
      .then((data) => {
        this.setState({
          showUserForm: true,
          userToEdit: data,
        });
      });
  };

  render() {
    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb
          style={{ padding: 24 }}
          separator={<RightOutlined style={{ fontSize: "75%" }} />}
        >
          <Breadcrumb.Item>
            <a href="/home">Accueil</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Paramétrage</Breadcrumb.Item>
          <Breadcrumb.Item>Utilisateurs</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          title={'Utilisateurs'}
          extra={[
            <Button
              key="add"
              type="primary"
              size="large"
              onClick={this.addUser}
            >
              Nouvel utilisateur
            </Button>
          ]}
        />
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <UserTable ref={this.userTable} onEdit={this.onUserEditHandler} />
          <UserForm
            onCreated={this.onCreatedHandler}
            onClose={() => {
              this.setState({ showUserForm: false });
            }}
            visible={this.state.showUserForm}
            user={this.state.userToEdit}
          />
        </div>
      </Content>
    );
  }
}

export default Users;
